// extracted by mini-css-extract-plugin
export default {"label":"PaymentsOSErrorLabel_label__aJ1I6","icon":"PaymentsOSErrorLabel_icon__92SkV","content":"PaymentsOSErrorLabel_content__gnsVL"};